import { Alert, AlertTitle, Box, Tab, Tabs, useMediaQuery } from '@mui/material'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { Footer } from '../../components/Footer/Footer'
import { ProgressBar } from '../../components/ProgressBar/ProgressBar'
import { container, flexcol, flexItemCenter, flexItemColumn, flexItemColumnLeft, flexItemLeft, flexrow, root } from '../../global'
import { appTheme } from '../../theme'
import webinar from '../../images/RequestingType/Webinar.svg'
import webcast from '../../images/RequestingType/Webcast.svg'
import podcast from '../../images/RequestingType/Podcast.svg'
import series from '../../images/RequestingType/Series.svg'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { eventDetail, updateEventtype } from '../../services/EventService'
import moment from 'moment'
import { ApprovalStatus, Role } from '../../services/Types'
import { isPodcastEnabled } from '../../config/featureFlags'

let user: any = localStorage.getItem('user')
if (user) user = JSON.parse(user)

var isWebView = true
var isMobView = false
const Item = styled(Paper)(({ theme }) =>
  isWebView
    ? { padding: theme.spacing(0, 6, 3, 6) }
    : { padding: theme.spacing(0, 4, 3, 4) }
)

const baseRequestTypes = [
  {key: 'Webinar', title: 'Webinar', icon: webinar, description: 'A WorkforceGPS webinar is a live, structured virtual event that is appropriate for engaging directly with the audience.'},
  {key: 'Webcast', title: 'Webcast', icon: webcast, description: 'A WorkforceGPS webcast is a pre-recorded presentation and is appropriate for structured content delivery without a live audience.'},
  {key: 'Podcast', title: 'Podcast', icon: podcast, description: 'A WorkforceGPS podcast is an audio only recording and is appropriate for listening to discussions without a visual presentation.'},
  {key: 'Series', title: 'Series/Convening', icon: series, description: '<b>Series</b>: Events scheduled with weeks or months between them. Each event is administered individually and typically requires fewer special considerations.<br/><br/><b>Convening</b>: A set of related events occurring within a short period, typically on consecutive days or with fewer than three business days between them. The WorkforceGPS Events team will create the meta and individual event pages in one batch before sending the event invitation to prospective attendees.'}
]

const requestTypes = isPodcastEnabled
  ? baseRequestTypes
  : baseRequestTypes.filter(request => request.key !== 'Podcast')

function a11yProps(index: number) {
  return {
    id: `requesting-type-view-tab-${index}`,
    'aria-controls': `requesting-type-view-tabpanel-${index}`,
  };
}

export default function RequestingTypePage() {
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))
  isMobView = useMediaQuery(appTheme.breakpoints.down('md'))
  const [requestingType, setRequestingType] = useState(requestTypes[0].key)
  const [event, setEvent] = useState<any>({})
  const navigate = useNavigate()

  let { id } = useParams()

  const updateEventType = async () => {
    try {
      const results = await updateEventtype(event.id, requestingType)
      const { data } = results
      if (data) {
        if (data.updateEventtype.statusCode === 200) {
          //navigate('/event/staff/'+eventData.id);
        }
      }
    } catch (error) {
      //displayServerError()
    }
  }

  useEffect(() => {
    if (user.approvalStatus !== ApprovalStatus.APPROVED) {
      return navigate('/')
    }

    const loadEventData = async () => {
      try {
        const { data } = await eventDetail(Number(id))
        if (data) {
          if (data.eventDetail.statusCode === 200) {
            let eventData = data.eventDetail.data
            if (eventData.creater.id !== user.id && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            if (eventData.status.startsWith('APPROVAL') && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            let liveRoomBooking = eventData.roomBooking?.find((x: any) => x.category === 'live')
            if (liveRoomBooking && Number(liveRoomBooking.date) < moment.utc().set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf() && user.role !== Role.ADMIN) {
              return navigate('/')
            }
            setEvent(eventData)
            setRequestingType(eventData.eventType)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (id !== undefined && id !== null) {
      loadEventData()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = (event: string) => {
    setRequestingType(event)
    localStorage.setItem('eventType', event)
  }

  const nextClick = async () => {
    if (id !== undefined && id !== null) {
      await updateEventType()
      navigate('/event/info/' + id)
    } else {
      localStorage.setItem('eventType', requestingType)
      navigate('/event/info/')
    }
  }

  const backClick = async () => {
    navigate('/')
  }

  return (
    <Box style={root}>
      <ProgressBar activePageTitle='Event Info' requestType={requestingType} />
      <Item
        sx={{
          bgcolor: 'rgba(0, 0, 0, 0.02)',
          pb: { xs: '100px' }
        }}
      >
          <Box style={flexItemCenter}>
            <Box style={flexcol} sx={{ gap: '12px', width: '600px' }}>
              <Typography variant="h1">
                What type of event are you requesting?
              </Typography>
              <Alert severity='warning'>
                <AlertTitle>Note: Once your event is approved, revisions to event features cannot be guaranteed.</AlertTitle>
                <Typography variant="body2">
                  Ensure that the event type you choose is appropriate as it will be used to determine the event details you will be able to select.
                </Typography>
              </Alert>
              <Box style={flexItemColumn}>
                <Tabs
                  value={requestingType}
                  orientation={'vertical'}
                  variant='scrollable'
                  scrollButtons={false}
                  TabIndicatorProps={{
                    style: { display: 'none' }
                  }}
                  sx={{
                    backgroundColor: 'transparent',
                    '& .MuiButtonBase-root.MuiTab-root': {
                      color: 'black',
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                      borderRadius: '16px',
                      border: 'none',
                      padding: '16px 8px',
                      background: 'white',
                      cursor: 'pointer',
                      maxWidth: 'inherit',
                    },
                    '& .MuiButtonBase-root.MuiTab-root:hover': {
                      backgroundColor: '#F3F4F3',
                    },
                    '& .MuiTab-root.Mui-selected': {
                      backgroundColor: '#DADCEC',
                      border: '2px solid #9C9C9C',
                    }
                  }}
                >
                  {requestTypes.map((request, index) => (
                    <Tab
                      key={index}
                      {...a11yProps(index)}
                      value={request.key}
                      disableFocusRipple={true}
                      disableRipple={true}
                      onClick={() => {
                        handleClick(request.key)
                      }}
                      label={
                        <Box style={flexrow}
                          sx={{
                            alignItems: 'flex-start',
                          }}
                        >
                          <Box
                            component='img'
                            src={request.icon}
                            alt={request.title}
                          />
                          <Box style={flexItemColumnLeft}>
                            <Typography variant="h2">
                              {request.title}
                            </Typography>
                            <Typography variant="body2">
                              <div dangerouslySetInnerHTML={{ __html: request.description }} />
                            </Typography>
                          </Box>
                        </Box>
                      }
                    ></Tab>
                  ))}
                </Tabs>
              </Box>
            </Box>
          </Box>

        <Footer
          // saveExit={saveExit}
          nextClick={nextClick}
          backClick={backClick}
          activePageTitle='Requesting Type'
          canMoveNext={true}
        ></Footer>
      </Item>
    </Box>
  )
}
